import MedicationDose from "./MedicationDose"
import {
    DosedMedicationGroup,
    DosedSingleMedicationEntry,
    GetPatientsOfProfessionalResponsePayload, MedicationGroupATCs,
    MedicationPreConditions,
    QuestionnaireTimestamp, SingleMedicationList
} from "pokal_api"
import { ArrayElement } from "../../types/ArrayElement"
import { PatientSFQPreconditions } from "../questions/PatientHasSFQValue"

class MedicationQuestionnaireInput {
    public medication: MedicationDose[]
    public comedication: MedicationDose[]
    public phqScore: number | null
    public preconditions: MedicationPreConditions
    public patient: ArrayElement<GetPatientsOfProfessionalResponsePayload>
    public timestamp: QuestionnaireTimestamp
    public sfqPreconditions: PatientSFQPreconditions | null
    public symptomImprovement: boolean

    constructor(
        medication: MedicationDose[],
        comedication: MedicationDose[],
        patient: ArrayElement<GetPatientsOfProfessionalResponsePayload>,
        timestamp: QuestionnaireTimestamp,
        phqScore: number | null,
        preconditions: MedicationPreConditions,
        sfqPreconditions: PatientSFQPreconditions | null,
        symptomImprovement: boolean
    ) {
        this.medication = medication
        this.comedication = comedication
        this.phqScore = phqScore
        this.preconditions = preconditions
        this.patient = patient
        this.timestamp = timestamp
        this.sfqPreconditions = sfqPreconditions
        this.symptomImprovement = symptomImprovement
    }

    getMedicationEntriesByAtc(atc: string): MedicationDose[] {
        return [
            ...this.medication.filter((elem) => elem.atc.startsWith(atc)),
            ...this.comedication.filter((elem) => elem.atc.startsWith(atc))
        ]
    }

    doseSum(elems: MedicationDose[]) {
        let sum = 0
        for (const elem of elems) sum += elem.dose
        return sum
    }

    patientAgeIsAtLeast(age: number) {
        return this.getPatientAge() >= age
    }

    //TODO: Move to date api
    getPatientAge() {
        const today = new Date()
        const birthDate = new Date(this.patient.birthdate)
        let age = today.getFullYear() - birthDate.getFullYear()
        const m = today.getMonth() - birthDate.getMonth()
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--
        }
        return age
    }

    patientTakes(
        medication: DosedSingleMedicationEntry,
    ): MedicationDose[] | null {
        const entry = SingleMedicationList[medication.entry]
        const matches = this.getMedicationEntriesByAtc(entry.atc)
        if (matches.length === 0) return null
        if (!medication.dose) {
            return matches
        }
        if (this.doseSum(matches) >= medication.dose) {
            return matches
        }
        return null
    }

    patientTakesGroup(
        medication: DosedMedicationGroup,
    ): MedicationDose[] | null {
        const group = MedicationGroupATCs[medication.entry]
        const matches: MedicationDose[] = []
        for (const elem of group)
            matches.push(...this.getMedicationEntriesByAtc(elem.atc))
        if (matches.length === 0) return null
        if (!medication.dose) {
            return matches
        }
        if (this.doseSum(matches) >= medication.dose) {
            return matches
        }
        return null
    }
}

export default MedicationQuestionnaireInput
